import posthog from 'posthog-js'
import {
  sanitizePosthogEvent,
  sanitizePosthogProperties,
} from './posthogEventPolicy'

let isInitialized = false
let isCollectionEnabled = false
let hasResetCurrentSession = false

function hasPosthogConfiguration() {
  return process.env.REACT_APP_POSTHOG_ENABLED === 'true'
    && Boolean(process.env.REACT_APP_POSTHOG_KEY?.trim())
}

export function initializePosthog() {
  if (isInitialized) return true
  if (!hasPosthogConfiguration() || typeof window === 'undefined') return false

  try {
    posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
      api_host: process.env.REACT_APP_POSTHOG_HOST,
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
      capture_exceptions: false,
      disable_session_recording: true,
      person_profiles: 'never',
      opt_out_capturing_by_default: true,
      opt_out_persistence_by_default: true,
      advanced_disable_feature_flags: true,
      before_send: sanitizePosthogEvent,
    })
    isInitialized = true
    isCollectionEnabled = false
    hasResetCurrentSession = false
    return true
  } catch {
    return false
  }
}

export function isPosthogAvailable() {
  return isInitialized
}

export function isPosthogCollectionEnabled() {
  return isInitialized && isCollectionEnabled
}

export function capturePosthogEvent(eventName, properties = {}) {
  if (!isPosthogCollectionEnabled()) return false

  try {
    posthog.capture(eventName, sanitizePosthogProperties(properties))
    return true
  } catch {
    // 분석 도구 장애가 제품 기능에 영향을 주지 않게 한다.
    return false
  }
}

export function applyPosthogConsent(enabled) {
  if (!initializePosthog()) return false

  const shouldEnable = enabled === true
  if (shouldEnable === isCollectionEnabled) return shouldEnable

  if (shouldEnable) {
    posthog.opt_in_capturing()
    isCollectionEnabled = true
    hasResetCurrentSession = false
    return true
  }

  posthog.opt_out_capturing()
  posthog.reset()
  isCollectionEnabled = false
  hasResetCurrentSession = true
  return false
}

export function disablePosthog() {
  return applyPosthogConsent(false)
}

export function resetPosthog() {
  if (!initializePosthog()) return

  if (isCollectionEnabled) posthog.opt_out_capturing()
  if (!hasResetCurrentSession) posthog.reset()

  isCollectionEnabled = false
  hasResetCurrentSession = true
}

export function resetPosthogStateForTests() {
  isInitialized = false
  isCollectionEnabled = false
  hasResetCurrentSession = false
}
